import { render, staticRenderFns } from "./common-B05.vue?vue&type=template&id=69562db1&scoped=true"
import script from "./common-B05.vue?vue&type=script&lang=js"
export * from "./common-B05.vue?vue&type=script&lang=js"
import style0 from "./common-B05.vue?vue&type=style&index=0&id=69562db1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69562db1",
  null
  
)

export default component.exports